import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Barcode from "react-jsbarcode";
import ReactToPrint from "react-to-print";
import { createBarcodePrintList } from "../../../actions/BarcodePrintListAction";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Button,
  Drawer,
  Table,
} from "antd";

const OldBarcodelistView = ({ barcodelist, reload, count, createBarcodePrintList }) => {
  const columns = [
    { title: '#', dataIndex: 'serialNumber', key: 'serialNumber' },
    { title: 'Product', dataIndex: 'product', key: 'product' },
    { title: 'Variation', dataIndex: 'variation', key: 'variation' },
    { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
    { title: 'Qty', dataIndex: 'quantity', key: 'quantity' },
  ];

  const dataSource = barcodelist.current.map((barcode, index) => ({
    key: barcode.variation.barcode,
    serialNumber: index + 1,
    product: barcode.variation.product_code,
    variation: barcode.variation.Attribute_details,
    category: barcode.variation.category,
    barcode: barcode.variation.barcode,
    brand_name: barcode.variation.ProductDetails.brand_name,
    // quantity: barcode.Quantity,
    quantity: barcode.variation.quantity
  }));

  const handleprinttable = (data) => {
    console.log(data);
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data));
    console.log(formdata);
    createBarcodePrintList(formdata);
  }

  const componentRef = useRef();
  
  useEffect(() => {
    count.current = 0;
  }, [reload]);

  const barcodes = (obj) => {
    console.log("Generating barcodes for:", obj);
    // return Array.apply(null, { length: obj.Quantity }).map((bar, index) => {
    return Array.apply(null, { length: obj.variation.quantity }).map((bar, index) => {
      return (
        <div
          key={`${obj.variation.barcode}-${index}`}
          className="barcode-label"
          style={{
            width: "1.5in",
            height: "1in",
            padding: "2px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            pageBreakAfter: "always",
            border: "1px solid #e0e0e0",
            boxSizing: "border-box",
            overflow: "hidden"
          }}
        >
          <div style={{ 
            fontSize: "8px", 
            fontWeight: "700", 
            textAlign: "center",
            lineHeight: "1",
            marginBottom: "2px",
            marginTop: "10px",
          }}>
            {/* {obj.variation.Warehouse_name} */}
            STATION
          </div>
          
          <div style={{ 
            fontSize: "8px", 
            fontWeight: "500", 
            textAlign: "center",
            lineHeight: "1.1",
            marginBottom: "1px",
            // maxHeight: "12px",
            // overflow: "hidden"
          }}>
            {obj.variation.category} {obj.variation.title}
          </div>
          
          <div style={{ 
            fontSize: "8px", 
            fontWeight: "500", 
            textAlign: "center",
            marginBottom: "1px",
            overflow: "hidden"

          }}>
            ({obj.variation.ProductDetails.brand_name}) | {obj.variation.Attribute_details}
          </div>
          
          <div style={{ marginBottom: "0px" }}>
            <Barcode 
              options={{ 
                height: 20,
                width: 1.3,
                fontSize: 8,
                margin: 0,
                displayValue: true
              }} 
              value={obj.variation.barcode} 
            />
          </div>

          <div style={{ 
            fontSize: "8px", 
            fontWeight: "500", 
            textAlign: "center",
            marginBottom: "1px",
            // overflow: "hidden"
          }}>
            {obj.variation.batch_no}
          </div>
          
          {/* <div style={{ 
            textAlign: "center",
            marginTop: "-2px",
            lineHeight: "1"
          }}>
            <span style={{ 
              fontSize: "9px", 
              fontWeight: "700"
            }}>
              {obj.variation.selling_price}
            </span>
            <span style={{ 
              fontSize: "5px", 
              fontWeight: "500",
              marginLeft: "1px"
            }}>
              (+VAT)
            </span>
          </div> */}
        </div>
      );
    });
  };

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: 1.5in 1in;
              margin: 0;
            }
            
            body {
              margin: 0;
              padding: 0;
            }
            
            .barcode-label {
              page-break-after: always;
              border: none !important;
            }
            
            .no-print {
              display: none !important;
            }
            
            .print-container {
              margin: 0;
              padding: 0;
            }
          }
          
          @media screen {
            .barcode-label {
              margin-bottom: 10px;
            }
          }
        `}
      </style>

      <Row>
        <Col span={16}>
          <ReactToPrint
            trigger={() => <Button type="primary" className="no-print">Print Labels</Button>}
            content={() => componentRef.current}
            pageStyle={`
              @page {
                size: 1.5in 1in;
                margin: 0;
              }
            `}
          />
          <div ref={componentRef} className="print-container">
            {barcodelist.current.map((barcode, idx) => {
              return (
                <React.Fragment key={idx}>
                  {barcodes(barcode)}
                </React.Fragment>
              );
            })}
          </div>
        </Col>
        
        <Col span={7} offset={1} className="no-print">
          <Button 
            type="primary" 
            style={{ float: "right", marginBottom: "10px" }} 
            onClick={() => handleprinttable(dataSource)}
          >
            Save
          </Button>
          <Table 
            columns={columns} 
            dataSource={dataSource} 
            pagination={false} 
          />
        </Col>
      </Row>
    </>
  );
};

export default connect(null, { createBarcodePrintList })(OldBarcodelistView);
